import { render, staticRenderFns } from "./AddToAppleWallet.vue?vue&type=template&id=55b9b32c&lang=pug"
import script from "./AddToAppleWallet.vue?vue&type=script&lang=js"
export * from "./AddToAppleWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.96.1__lodash@4.17.21__lkjqg4lemhx3tcnq4xpodjyioi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports